import React from 'react';
import { Label, FormGroup } from 'reactstrap';
import { useFormContext, get } from "react-hook-form";
import Tooltip from './Tooltip';
import './Formgroup.css'

type TextareaFieldProps = {
    label: string;
    name: string;
    className?: string;
    defaultValue?: string;
    rows?: number;
    cols?: number;
    disabled?: boolean;
    readOnly?: boolean;
    required?: boolean;
    tooltipBody?: () => JSX.Element;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

function TextareaField({ label, name, className, defaultValue, rows, cols, disabled, required, tooltipBody, readOnly }: TextareaFieldProps) {
    const { register, formState: { errors } } = useFormContext();
    const error = get(errors, name);

    const validations = {
        required: required
    };

    return (
        <FormGroup>
            <Label htmlFor={name}>{label}</Label>
            {tooltipBody &&
                <Tooltip tooltipBody={tooltipBody()} />
            }
            <textarea {...register(name, validations)}
                name={name}
                rows={rows}
                cols={cols}
                className={className ? `form-control  ${className}` : 'form-control'} 
                defaultValue={defaultValue}
                disabled={disabled}
            />
            <div className="form-error-wrapper">
                {error?.type === 'required' && 'This is a required field'}
            </div>
        </FormGroup>
    );
}
export default TextareaField;
